/**
 * Error thrown when getting HTTP responses
 * @beta
 */
export class ResponseError extends Error {
    /** HTTP status code of the error */
    statusCode;
    /** Array of ErrorDetails */
    details;
    /** String DID of the recipient of the error */
    recipientDid;
    /** URL where the error was thrown */
    url;
    constructor(params) {
        super();
        this.name = this.constructor.name;
        this.statusCode = params.statusCode;
        this.details = params.details;
        this.recipientDid = params.recipientDid;
        this.url = params.url;
    }
}
